// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2d7f6042","239":"af58270e","455":"d2706a2e"}[chunkId] + ".chunk.js";
};